import gql from 'graphql-tag';

import { DetailsPanelUserFragment } from './fragments/DetailsPanelUserFragment.fragment';

export const DetailsPanelContentOwnerQuery = gql`
	query DetailsPanelContentOwnerQuery($contentId: ID!, $status: String!) {
		content(id: $contentId, status: [$status]) {
			nodes {
				id
				history {
					ownedBy {
						...DetailsPanelUserFragment
					}
				}
			}
		}
	}
	${DetailsPanelUserFragment}
`;
